import { API_ORDER_PREFIX } from '@shared/config/api/api-prefixes';
import { BuyOrderDataResponse, BuyOrderDataRequest } from './buy-order-types';
import { orderBaseApi } from '@entities/order/api/base';

export const orderBuyApi = orderBaseApi.injectEndpoints({
    endpoints: (build) => ({
        buyOrder: build.mutation<BuyOrderDataResponse, BuyOrderDataRequest>({
            query: ({ orderId, ...body }) => {
                return {
                    url: `${API_ORDER_PREFIX}/${orderId}/pass`,
                    method: 'POST',
                    body,
                };
            },
            invalidatesTags: ['OrdersList', 'OrderItem'],
        }),
    }),
});

export const { useBuyOrderMutation } = orderBuyApi;
